import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Dribbler Game';
}



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/app.component.ts